module.exports = __webpack_public_path__ + "static/media/6.7.2ce517e5.zip";